import { Box, Divider, Typography } from "@mui/material";
import { AppointmentCardStyled } from "./appointment-card.styles";
import { AppointmentCardProps } from "./types";

const AppointmentCard: React.FC<AppointmentCardProps | any> = ({ data }) => {
  return (
    <AppointmentCardStyled className="appointment-card">
      <Box className="top-part">
        <Box className="name-and-time">
          <Typography className="name">{data.name}</Typography>
          <Typography className="time">{data.time}</Typography>
        </Box>
        <Box>
          <Typography className="date">{data.date}</Typography>
        </Box>
      </Box>
      <Divider />
      <Box className="bottom-part">
        <Box>
          <Typography className="label">Address</Typography>
          <Typography className="value">{data.address}</Typography>
        </Box>
        <Box>
          <Typography className="label">No. of pets</Typography>
          <Typography className="value">{data.noOfPets}</Typography>
        </Box>
      </Box>
    </AppointmentCardStyled>
  );
};

export default AppointmentCard;
